module.exports = __webpack_public_path__ + "media/images/company/company_03_sub-a0b68f8ea461bf853225806436cf831f.jpg";